export class ErrorLevelInfo extends Error {}
